module.exports = __webpack_public_path__ + "static/img/16.2d4f3de.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/1/2/5/eng/16.png
// module id = 1kn4
// module chunks = 0